"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReducer = void 0;
function buildReducer(preloadedState, reducers) {
    return (state = preloadedState, action) => {
        if (action && action.type) {
            const reducer = reducers[action.type];
            if (reducer) {
                // if we found matched reducer
                return reducer(state, action.payload);
            }
        }
        return state;
    };
}
exports.buildReducer = buildReducer;
